"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UserExclamationSolid: function() {
        return UserExclamationSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const UserExclamationSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M12 1C9.23858 1 7 3.23858 7 6C7 8.76142 9.23858 11 12 11C14.7614 11 17 8.76142 17 6C17 3.23858 14.7614 1 12 1Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M12 12C6.47715 12 2 16.4772 2 22C2 22.5523 2.44772 23 3 23H18.171C18.0604 22.6872 18.0002 22.3506 18.0002 22C18.0002 21.4502 18.1482 20.9349 18.4064 20.4918C18.1552 20.0544 18.0111 19.5477 18.0098 19.0073L18 15.0073C17.9992 14.6925 18.047 14.3888 18.1363 14.1034C16.4422 12.7852 14.3128 12 12 12Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M21.0117 20C20.4594 20.0013 20.0106 19.5547 20.0093 19.0024L19.9995 15.0024C19.9982 14.4502 20.4448 14.0014 20.9971 14C21.5494 13.9987 21.9982 14.4453 21.9995 14.9976L22.0093 18.9976C22.0106 19.5498 21.564 19.9987 21.0117 20Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M22.0098 22C22.0098 21.4477 21.562 21 21.0098 21H20.9998C20.4475 21 19.9998 21.4477 19.9998 22C19.9998 22.5523 20.4475 23 20.9998 23H21.0098C21.562 23 22.0098 22.5523 22.0098 22Z",
            fill: "currentColor"
        })
    ]
}), "UserExclamationSolid");
const _default = UserExclamationSolid;
